<template>
	<div class="message-bubble" v-if="banks.length > 0">
		<v-card v-for="(bank, index) in banks" :key="index">
			<v-card-subtitle>
				{{ bank.text }}
			</v-card-subtitle>
			<v-card-text>
				<v-list rounded dense>
					<v-list-item-group color="primary">
						<v-list-item
							v-for="(item, i) in bank.additionalParameters"
							:key="i"
							@click="show_bill(item)"
						>
							<v-list-item-icon>
								<v-icon>mdi-bank</v-icon>
							</v-list-item-icon>
							<v-list-item-content>
								<v-list-item-title>
									{{ `${item.bank_name} (${item.account_type})` }}
								</v-list-item-title>
							</v-list-item-content>
						</v-list-item>
					</v-list-item-group>
				</v-list>
			</v-card-text>
			<v-card-actions>
				<BackBtn return_to="cart" :text="true" />
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</div>
</template>

<script>
/**
 * Bancos y/o metodos de pago
 */
import BackBtn from "./BackBtn";
export default {
	components: {
		BackBtn,
	},
	computed: {
		banks() {
			return this.$store.getters["chatStore/get_banks"];
		},
	},
	mounted() {
		let fd = new FormData();
		fd.append("driver", "web");
		fd.append("message", `banks:${this.$route.params.id}`);

		const data = {
			id: this.$route.params.id,
			data: fd,
		};

		this.$store.dispatch("chatStore/get_banks", data);
	},
	methods: {
		show_bill(item) {
			this.$store.commit("chatStore/BANK_SELECTED", item);
			this.$store.commit("chatStore/STATUS", "bill");
		},
	},
};
</script>
